import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { EventCalendar } from '@src/components/sco/Events/EventCalendar';
import { EventProfile } from '@src/components/sco/Events/EventProfile';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { ContentTrackStep } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
type WorkshopStepProps = {
  search?: {
    title?: string;
    hostFirstName?: string;
    hostLastName?: string;
  };
  contentTrackStep: ContentTrackStep;
};
export const WorkshopStep = props => {
  const $ = _c(15);
  const trackContext = useContentTrackContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = WorkshopStep.queries.groupEvent();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.search) {
    t1 = {
      variables: {
        ...props.search
      }
    };
    $[1] = props.search;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[3] !== query.loading) {
    t2 = query.loading && <Center><Spinner /></Center>;
    $[3] = query.loading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== query.error) {
    t3 = query.error && <Box>{"WorkshopStep Error: "}{query.error.toString()}</Box>;
    $[5] = query.error;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.contentTrackStep || $[8] !== query.data?.groupEvents || $[9] !== trackContext) {
    t4 = query.data?.groupEvents?.items && <ViewableTracker parentId={trackContext.contentTrackEnrollment?.contentTrackEnrollmentId} parentType="ContentTrackEnrollment" trackScrolling={true} viewableContext="workshop" viewableId={props.contentTrackStep.id} viewableType={props.contentTrackStep.__typename}>{query.data?.groupEvents?.items[0] ? <EventProfile event={query.data?.groupEvents.items[0]} hideComments={true} /> : <EventCalendar />}</ViewableTracker>;
    $[7] = props.contentTrackStep;
    $[8] = query.data?.groupEvents;
    $[9] = trackContext;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <Box>{t2}{t3}{t4}</Box>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
WorkshopStep.queries = {
  groupEvent: () => gql`
    query($title: String) {
      groupEvents(search: $title, typeKey: "workshop", pageSize: 1, isFuture: true, order: [["startsAt", "asc"]]) {
        id
        items {
          id
          ${EventProfile.fragments.GroupEvent()}
        }
      }
    }
  `
};